import { Button, Skeleton } from '@sea-snag/ui';
import { Link } from '@tanstack/react-router';

import { usePublicMarketStats } from '../../hooks/use-public-market-stats';
import { LandingTicker } from './landing-ticker';

function focusBetaEmail() {
  const section = document.getElementById('beta');
  if (!section) return;
  section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  setTimeout(() => {
    document.getElementById('beta-email')?.focus({ preventScroll: true });
  }, 600);
}

export function LandingHero({ isLoading }: { isLoading: boolean }) {
  const { data } = usePublicMarketStats();
  const priceChangesLast7d = data?.priceChangesLast7d ?? 30_000;

  return (
    <section className="relative pt-32 pb-20">
      <div className="mx-auto max-w-4xl px-6">
        <p className="mb-8 font-mono text-xs uppercase tracking-[0.18em] text-muted-foreground">
          Charter pricing intelligence · Closed beta
        </p>

        <h1 className="mb-8 text-4xl font-semibold leading-[1.05] tracking-tight text-foreground sm:text-5xl md:text-6xl">
          Your competitors changed prices{' '}
          <span className="font-mono tabular-nums">{priceChangesLast7d.toLocaleString()}</span>{' '}
          times last week.
          <br />
          Did you?
        </h1>

        <p className="mb-10 max-w-2xl text-lg text-muted-foreground md:text-xl">
          Generic market averages don&rsquo;t price your fleet. Sea Snag tracks the exact
          competitors you compete with, selected by you and refreshed continuously, and turns their
          moves into pricing decisions you can act on within minutes.
        </p>

        <div className="mb-16 flex flex-col items-start gap-3 sm:flex-row sm:items-center">
          {isLoading ? (
            <>
              <Skeleton className="h-11 w-44 rounded-md" />
              <Skeleton className="h-11 w-36 rounded-md" />
            </>
          ) : (
            <>
              <Button size="lg" onClick={focusBetaEmail}>
                Request beta access →
              </Button>
              <Button size="lg" variant="ghost" asChild>
                <a href="#competitor-sets">See it in action</a>
              </Button>
              <span className="ml-0 sm:ml-4 text-sm text-muted-foreground">
                Already onboard?{' '}
                <Link to="/login" className="underline-offset-4 hover:underline">
                  Sign in
                </Link>
              </span>
            </>
          )}
        </div>

        <LandingTicker />
      </div>
    </section>
  );
}
